import ApiService from "../../services/ApiService";
import translate from "../../services/Translate";

export const fetchAllDelayedCohorts = (setCohorts: Function, setLoading: Function, language: string) => {
  setLoading(true);

  ApiService.get("cohorts/delayed")
    .then((response) => setCohorts(response.data.delayed_cohorts))
    .catch((error) => {
      console.error("Error fetching delayed cohorts:", error);
      alert(translate(language, "ERROR.API_ERROR"));
    })
    .finally(() => setLoading(false));
};
